/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The kind of MCP surface that serves the skill.
 */
export const LinkSkillRequestBodyTargetKind = {
  McpServer: "mcp_server",
  MetaMcpServer: "meta_mcp_server",
  OrganizationGateway: "organization_gateway",
} as const;
/**
 * The kind of MCP surface that serves the skill.
 */
export type LinkSkillRequestBodyTargetKind = ClosedEnum<
  typeof LinkSkillRequestBodyTargetKind
>;

export type LinkSkillRequestBody = {
  /**
   * The skill ID.
   */
  id: string;
  /**
   * The MCP server that serves the skill. Required when target_kind is mcp_server.
   */
  mcpServerId?: string | undefined;
  /**
   * The gateway that serves the skill. Required when target_kind is meta_mcp_server.
   */
  metaMcpServerId?: string | undefined;
  /**
   * An optional valid version to pin instead of serving the latest valid version.
   */
  pinnedVersionId?: string | undefined;
  /**
   * The kind of MCP surface that serves the skill.
   */
  targetKind: LinkSkillRequestBodyTargetKind;
};

/** @internal */
export const LinkSkillRequestBodyTargetKind$outboundSchema: z.ZodMiniEnum<
  typeof LinkSkillRequestBodyTargetKind
> = z.enum(LinkSkillRequestBodyTargetKind);

/** @internal */
export type LinkSkillRequestBody$Outbound = {
  id: string;
  mcp_server_id?: string | undefined;
  meta_mcp_server_id?: string | undefined;
  pinned_version_id?: string | undefined;
  target_kind: string;
};

/** @internal */
export const LinkSkillRequestBody$outboundSchema: z.ZodMiniType<
  LinkSkillRequestBody$Outbound,
  LinkSkillRequestBody
> = z.pipe(
  z.object({
    id: z.string(),
    mcpServerId: z.optional(z.string()),
    metaMcpServerId: z.optional(z.string()),
    pinnedVersionId: z.optional(z.string()),
    targetKind: LinkSkillRequestBodyTargetKind$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
      metaMcpServerId: "meta_mcp_server_id",
      pinnedVersionId: "pinned_version_id",
      targetKind: "target_kind",
    });
  }),
);

export function linkSkillRequestBodyToJSON(
  linkSkillRequestBody: LinkSkillRequestBody,
): string {
  return JSON.stringify(
    LinkSkillRequestBody$outboundSchema.parse(linkSkillRequestBody),
  );
}
